import {MatSnackBarConfig} from "@angular/material";
import {ActionWithPayload} from "@store/reducers";
import {Action} from "@ngrx/store";

export const SNACKBAR_OPEN = 'SNACKBAR_OPEN';
export const SNACKBAR_CLOSE = 'SNACKBAR_CLOSE';


export class SnackbarOpen implements ActionWithPayload<MatSnackBarConfig> {
  readonly type = SNACKBAR_OPEN;
  constructor(public payload: MatSnackBarConfig) {}
}

export class SnackbarClose implements Action {
  readonly type = SNACKBAR_CLOSE;
}

export type SnackbarAction = SnackbarOpen | SnackbarClose;



// WEBPACK FOOTER //
// ./src/app/store/actions/snackbar.action.ts